<template>
 
</template>



<script>
  import axios from 'axios'

  export default {
    data: () => ({ }),

    created : function() {
        localStorage.clear();
        sessionStorage.clear();
        this.$store.commit('UNSET_LOGGED_IN')   
        this.$router.push({'path': '/security/login'}) 
   }
 };



</script>



// WEBPACK FOOTER //
// src/components/security/logoutPage.vue